'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var entitlementsPropType = _propTypes2.default.arrayOf(_propTypes2.default.string);

exports.default = entitlementsPropType;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/entitlementsPropType.js
// module id = 118
// module chunks = 11